import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { generateTokensCSS, updateTokenRegistry } from 'designSystem/tokens/resolver';

// Component to inject tokens.css into the document
export const TokenStylesInjector = () => {
	const designSystemContent = useSelector((r: RootReducer) => r.mode.designSystemContent);

	useEffect(() => {
		if (!designSystemContent?.tokens?.all) {
			return;
		}

		// Update the token registry
		updateTokenRegistry(designSystemContent.tokens.all);

		// Generate CSS from tokens
		const cssContent = generateTokensCSS(designSystemContent.tokens.all);

		// Find or create style element for design system tokens
		let styleElement = document.getElementById('design-system-tokens') as HTMLStyleElement;
		if (!styleElement) {
			styleElement = document.createElement('style');
			styleElement.id = 'design-system-tokens';
			document.head.appendChild(styleElement);
		}

		// Update the CSS content
		styleElement.textContent = cssContent;
	}, [designSystemContent?.tokens?.all]);

	return null;
};
